import React from "react"
import { Routes, Route } from "react-router-dom"
import Main from "./pages/Main"
import Login from "./pages/Login"
import ErrorPage from "./pages/ErrorPage"
import Protected from "./components/Protected"
import AddUser from "./pages/AddUser"
import About from "./pages/About"
import "./App.css"
import Footer from "./components/Footer"

function App() {
  return (
    <div className='relative grid grid-rows-[1fr] overflow-y-hidden w-full min-h-dvh font-sans  pb-12 bg-slate-600 '>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/adduser' element={<AddUser />} />
        <Route
          path='/main/:userId'
          element={
            <Protected>
              <Main />
            </Protected>
          }
        />
        <Route
          path='/about'
          element={
            <Protected>
              <About />
            </Protected>
          }
        />
        <Route path='*' element={<ErrorPage />} />
      </Routes>
      <Footer />
    </div>
  )
}

export default App
